import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { dollars } from "LIB/formatters/currency";
import { translateProps } from "MODULES/shared/decorators";
import { decorators } from "@orange-marmalade/paginate-this";

function Total({ salesOrder, results, loading }) {
  if (loading) return null;

  return (
    <span className="pull-right">
      <span className="small text-muted">{results.length} Item(s)</span>
      &nbsp;&nbsp;Total: {dollars(salesOrder.get("total"))}
    </span>
  );
}

const withListId = translateProps(() => ({
  listId: "salesOrders/lineItems"
}));

export default withListId(decorators.tabulate(Total));

Total.propTypes = {
  salesOrder: T.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Total.jsx